import React from 'react';

class MultipleAnswerOption extends React.Component {
  constructor(){
    super();
    this.state = { checked: false }
    this.onClickHandler = this.onClickHandler.bind(this);
  }

  onClickHandler = (target) => {
    const {field, value} = this.props;
    const {checked} = this.state;
    if(!checked){
      this.props.onChangeHandler(field, value, null, null, []);
    }
    else{
      this.props.onChangeHandler(field, null, null, null, []);
    }
    this.setState({checked: !checked});  

  }

  getInput = (field, id, value, isChecked) => {
    if(isChecked){
      return <input className="form-check-input"   
                  type="checkbox" 
                  name={field} 
                  id={id} 
                  value={value}
                  onClick={this.onClickHandler}
                  defaultChecked
                  />
    }
    return <input className="form-check-input"   
                  type="checkbox" 
                  name={field} 
                  id={id} 
                  value={value}
                  onClick={this.onClickHandler}
                  />
  }

  componentDidMount = () =>{
    this.setState({ checked: this.props.isChecked });    

  }

  render() {
    const {field, value, text, keyIdentifier, isChecked} = this.props;
    const inputElement = this.getInput(field,`${field}${keyIdentifier}`, value, isChecked);
    return (
        <div className="option" >
            {inputElement}
            <label className="form-check-label" htmlFor={`${field}${keyIdentifier}`}>
                {text}
            </label>
        </div>
    )}
}

export default MultipleAnswerOption;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/QuestionsTypes/MultipleAnswerOption.js